<!-- eslint-disable -->
<template lang="pug">
    .victory
        .victory-background
            img(src="../../../assets/images/battles/result/victory-background.png")
        .victory-clevik
            img(src="../../../assets/images/battles/result/victory-clevik.png")
        .victory-box
            .victory-box__title {{ $i18n.t('battle.battle_victory') }}
            .victory-box__text(v-if='!isTrainingBattle' v-html="$i18n.t('battle.battle_victory_bonus')")
            .victory-box__text(v-if="isForceCompleted") {{ $i18n.t('battle.battle_opponent_didnt_reconnect') }}
            .victory-box__star(v-if='!isTrainingBattle')
                img(src="../../../assets/images/battles/bage.svg")
            .victory-box__buttons
                cs-button(
                    type="button",
                    color="blue",
                    @click="$router.push({name: playMoreRouteString})"
                ) {{ $i18n.t('battle.battle_play_more') }}
                cs-button(
                    v-if="!isForceCompleted"
                    type="button",
                    color="blue",
                    pattern="primary-outline",
                    @click="$emit('showResultStats')"
                ) {{ $i18n.t('battle.battle_view_stats') }}
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            playMoreRouteString: {
                type: String,
                default: ''
            },
            isTrainingBattle: {
                type: Boolean,
                default: false
            },
            isForceCompleted: {
                type: Boolean,
                default: false
            },
        },
    }
</script>

<style scoped lang="scss">
    .victory {
        margin: 30px 0;
        text-align: center;
    }
    .victory-background {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        pointer-events:none;
        img {
            width: 100vw;
            height: 50vh;
            @media screen and (max-width: 992px) {
                height: 25vh;
            }
        }
    }
    .victory-clevik {
        height: 180px;
    }
    .victory-box {
        background: #F7F7FF;
        border-radius: 20px;
        max-width: 600px;
        margin: 0 auto;
        padding: 30px;
        @media screen and (max-width: 360px) {
            padding: 20px;
        }
    }
    .victory-box__buttons {
        :first-child {
            margin-right: 10px;
        }
    }
    .victory-box__title {
        font-size: 22px;
        font-weight: 500;
        margin-bottom: 5px;
    }
    .victory-box__text {
        margin-bottom: 10px;
    }
    .victory-box__star {
        margin-bottom: 30px;
    }
    .victory-box__buttons {
        display: flex;
        flex-direction: column;
        @include media($md) {
            flex-direction: row;
            justify-content: center;
        }
    }
    .victory-box__buttons .cs-button:nth-child(2) {
        margin: 20px 0 0 0;
        @include media($md) {
            margin: 0 0 0 20px;
        }
    }
</style>
